import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { APP_VERSION } from "../lib/api";
import { currentMonthIST } from "../lib/datetime";
import { PendingApprovalsProvider } from "../context/PendingApprovalsContext";
import { EventsProvider } from "../context/EventsContext";

export default function AppShell() {
  return (
    // Fixed-height shell: the sidebar, top header, and footer stay put;
    // only <main> scrolls. [height:100dvh] keeps it correct on mobile
    // browsers whose viewport height changes as the URL bar shows/hides.
    // The provider lives inside the authenticated shell so the count is only
    // ever fetched for a signed-in user, and inside the router so it can refetch
    // on navigation.
    <PendingApprovalsProvider>
    <EventsProvider>
    <div className="h-screen [height:100dvh] flex bg-callisto-app overflow-hidden">
      <div className="hidden md:flex w-72 shrink-0">
        <Sidebar />
      </div>
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        {/* The vertical padding belongs on the inner wrapper, not on <main>.
            A sticky box resolves its offsets against the scroll container's
            *content* box, so `top: 0` inside a `py-10` <main> pins 40px down
            and leaves that 40px strip as a live window onto the scrolling
            content — rows visibly passing above the pinned heading. With the
            padding inside, it scrolls like any other content and a heading
            pins flush against main's top edge. The horizontal padding stays
            here: StickyHeading bleeds `-mx-4 md:-mx-8` to repaint it. */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden px-4 md:px-8">
          <div className="max-w-6xl mx-auto py-6 md:py-10 callisto-fade-in">
            <Outlet />
          </div>
        </main>
        {/* The shell is 100dvh and `viewport-fit=cover` makes that include the
            home indicator's strip, so without the bottom inset the footer's
            last row sits under it. */}
        <footer className="shrink-0 border-t border-callisto bg-white px-4 md:px-8 py-3 pb-[calc(0.75rem+var(--safe-area-bottom))] flex items-center justify-between text-xs text-callisto-muted">
          {/* The company's year, not the viewer's: `getFullYear()` reads the
              browser zone, which is a different year from IST for five and a
              half hours every New Year's Eve. */}
          <span>© {currentMonthIST().year} Callisto Pharmaceuticals Pvt. Ltd.</span>
          <span data-testid="app-footer-version" className="font-mono">
            {APP_VERSION}
          </span>
        </footer>
      </div>
    </div>
    </EventsProvider>
    </PendingApprovalsProvider>
  );
}
